import { useEffect, useState } from 'react';

let push: ((m: string, ms: number) => void) | null = null;
export const toast = (msg: string, ms = 2600) => push?.(msg, ms);

/** Prototype toast: ink pill sliding in from the top, polite live region. */
export function Toaster() {
  const [msg, setMsg] = useState('');
  const [show, setShow] = useState(false);
  useEffect(() => {
    let h: ReturnType<typeof setTimeout>;
    push = (m, ms) => {
      setMsg(m);
      setShow(true);
      clearTimeout(h);
      h = setTimeout(() => setShow(false), ms);
    };
    return () => {
      push = null;
      clearTimeout(h);
    };
  }, []);
  return (
    <div className={`toast ${show ? 'show' : ''}`} role="status" aria-live="polite">
      {msg}
    </div>
  );
}
